import type { Brand } from 'types/brands'

import { brandTranslationKeys } from '../../constants/brands'

export const getBrandTranslationKeys = (brandId: Brand['id']) =>
	brandTranslationKeys[brandId]
